/**
 * Format a snake_case or lowercase status string to Title Case.
 * e.g., "not_started" → "Not Started", "suspended" → "Suspended"
 *
 * Used across Matches List and Live Control pages.
 */
export function formatMatchStatus(status: string | null): string | null {
  if (!status) return null
  return status
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}
